<template>
  <app-page title="PDF Templates">
    <v-layout>
      <v-flex xs12>
        <errors-list :errorMessage="errorMessage" />

        <v-data-table :headers="headers" :items="items" :loading="loading" hide-actions>
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr>
              <grid-cell
                :header="header"
                :row="props.item"
                v-for="(header, index) in headers"
                :key="index"
                @action="onAction"
              ></grid-cell>
            </tr>
          </template>
        </v-data-table>
        <input
          type="file"
          ref="fileInput"
          style="visibility: hidden; opacity: 0; position: absolute; top: -999px; left: -999px;"
          @change="upload"
          accept="application/pdf"
        />
      </v-flex>
    </v-layout>
  </app-page>
</template>

<script>
import GridCell from '../components/GridCell';
import { getErrorMessage } from '../errorHandlers';
import ErrorsList from '../components/ErrorsList';

export default {
  name: 'Templates',
  components: { GridCell, ErrorsList },

  data() {
    return {
      items: [],
      currentRowId: null,
      title: 'PDF Templates',
      loading: false,
      errorMessage: '',
    };
  },

  computed: {
    headers() {
      return [
        { text: 'Name', sortable: false, value: 'name' },
        {
          text: 'Actions',
          width: 40,
          sortable: false,
          actions: (row) => [
            { icon: 'cloud_download', href: `/api/templates/pdf/${row.id}` },
            { icon: 'cloud_upload' },
          ],
        },
      ];
    },
  },

  methods: {
    async upload(event) {
      const files = event.target.files;

      if (!files || !files.length) {
        return;
      }

      try {
        this.loading = true;
        const url = `/api/templates/pdf/${this.currentRowId}`;
        const formData = new FormData();
        formData.append('file', files[0]);

        await this.$http.put(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },

    onAction({ action, row }) {
      this.currentRowId = row.id;
      if (action && action.icon === 'cloud_upload') {
        this.$refs.fileInput.click();
      }
    },

    async fetchData() {
      try {
        this.loading = true;
        const url = `/api/templates/pdf`;
        const { data } = await this.$http.get(url);

        this.items = data.map((type) => ({
          id: type,
          name: type,
        }));
        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.fetchData();
  },
};
</script>
